import {Kind} from "@/model/tennant/Kind";
import {PostalAddressResponse} from "@/types/service-response";

export default class PostalAddress {
    private constructor(
        readonly id: string,
        readonly kind: Kind,
        readonly street: string,
        readonly city: string,
        readonly zip: string
    ) {
    }

    public static createPostalAddress(responseNewAddress: PostalAddressResponse): PostalAddress {
        return new PostalAddress(
            responseNewAddress.id,
            responseNewAddress.kind,
            responseNewAddress.street,
            responseNewAddress.city,
            responseNewAddress.zip
        )
    }
}